export const AUDITORY_MODEL = {
  paso: 3,
  pasoDescripcion: 'PASO_DECLARACION_SALUD',
};
